import useMakePageScrollable from '@hooks/useMakePageScrollable';
import DeviceListPage from '@src/components/_shared/devices/DeviceListPage';
import { Device } from '@src/types/Device';
import { DeviceType } from '@src/types/devices/DeviceConfig.types';
import storeConnector from '@store/storeConnector';

interface BMSProps {
  currentUnit: Device;
}

const BMS = ({ currentUnit }: BMSProps) => {
  useMakePageScrollable();
  return (
    <DeviceListPage currentUnit={currentUnit} deviceType={DeviceType.BMS} />
  );
};

export default storeConnector(BMS, {
  service: ['currentUnit'],
});
